import { PAYMENT_REDIRECT, SHARE_FILE, SHARE_URL } from '@skippay/core/modules/clientInfo/actions';
import { delay } from '@skippay/core/utils/promiseUtils';

const webMiddleware = () => (next) => (action) => {
	const result = next(action);
	// eslint-disable-next-line default-case
	switch (action.type) {
		case PAYMENT_REDIRECT: {
			window.location = action.payload.gatewayRedirectUrl;
			return delay(50000); // fake promise pending until user is redirected
		}
		case SHARE_FILE:
			return (
				window.navigator.share &&
				navigator.canShare(action.payload) &&
				window.navigator.share(action.payload)
			);
		case SHARE_URL:
			return window.navigator.share && window.navigator.share(action.payload);
	}

	return result;
};

export default webMiddleware;
